<template>
  <div>
    <el-popover
      placement="bottom-end"
      popper-class="account-menu-popover r-popover"
      width="320"
      trigger="click"
      v-model="isVisible"
    >
      <div class="account-menu__button" slot="reference">
        <div
          :class="['account-menu__button-ava', !user.avatar ? 'border' : '']"
        >
          <img
            v-if="user.avatar"
            :src="`${baseURL}/${downloadURL}/${user.avatar}`"
            alt="Аватар пользователя"
          />
          <div v-else class="account-menu__no-avatar" />
        </div>
        <i class="el-icon-caret-bottom" />
      </div>
      <div class="account-menu" v-loading="disabled">
        <div class="account-menu__info">
          <div class="account-menu__avatar">
            <img
              v-if="user.avatar"
              :src="`${baseURL}/${downloadURL}/${user.avatar}`"
              alt="Аватар пользователя"
            />
            <div v-else class="account-menu__no-avatar" />
          </div>
          <div class="account-menu__user-info">
            <div class="account-menu__name">
              <r-title>
                {{ `${user.first_name} ${user.last_name}` }}
              </r-title>
            </div>
            <div class="account-menu__email">
              <r-text>{{ user.email }}</r-text>
            </div>
          </div>
        </div>
        <ul class="account-menu__list">
          <li
            v-for="item in accountActionList"
            :key="item.name"
            :class="['account-menu__item', { devided: item.devided }]"
            @click="actionClickHandler(item.name)"
          >
            <div
              class="account-menu__item-wrap"
              @click="switchToggler(item.name)"
            >
              <div
                class="account-menu__logout-icon"
                v-if="item.name === 'exit'"
              >
                <r-icon :name="`shutdown`"></r-icon>
              </div>
              <r-text>{{ $t(`account:${item.value}`) }}</r-text>
              <el-switch
                v-if="item.name === 'lang'"
                class="r-switch"
                v-model="langSwitcher"
                disabled
              />
              <el-switch
                v-if="item.name === 'theme'"
                class="r-switch"
                v-model="themeSwitcher"
                disabled
              />
            </div>
          </li>
        </ul>
      </div>
    </el-popover>
  </div>
</template>

<script>
import constants from "@/constants/url";
import { toggleBodyTheme } from "@/utils";
import { accountActionList } from "../config/";

export default {
  data() {
    return {
      theme: this.$store.state.theme,
      lang: this.$store.state.locale,
      currentProfileId: this.$store.state.profiles.currentProfile.id,
      baseURL: constants.URL,
      downloadURL: "download_share_resource",
      themeSwitcher: false,
      langSwitcher: false,
      disabled: false,
      isVisible: false,
      accountActionList
    };
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    }
  },
  methods: {
    actionClickHandler(item) {
      switch (item) {
        case "about":
        case "account":
        case "settings-reset":
          this.openModalBox(item);
          this.isVisible = false;
          break;
        case "exit":
          this.logout();
          break;
        default:
          break;
      }
    },
    switchToggler(item) {
      let value;

      switch (item) {
        case "lang":
          this.langSwitcher = !this.langSwitcher;
          value = this.langSwitcher ? "en" : "ru";
          this.changeLanguage(value);
          break;
        case "theme":
          this.themeSwitcher = !this.themeSwitcher;
          value = this.themeSwitcher ? "dark-theme" : "light-theme";
          this.changeTheme(value);
          break;
      }
    },
    openWindow(title) {
      const options = { title, type: title };

      this.$store.commit("ADD_NEW_OVERHEAD_WINDOW", options);
      this.$store.dispatch("SAVE_MAIN_USER_CONFIG");
    },
    openModalBox(val) {
      this.$store.commit("OPEN_MODAL_WINDOW", val);
    },
    async changeTheme(value) {
      this.disabled = true;
      const options = {
        id: this.currentProfileId,
        theme: value
      };
      this.theme = value;

      this.$store.commit("SET_THEME", value);
      toggleBodyTheme(value);
      await this.$store.dispatch("SAVE_MAIN_USER_CONFIG");
      this.$store.commit("UPDATE_PROFILES_TREE", options);

      if (this.disabled) setTimeout(() => (this.disabled = false), 300);
    },
    async changeLanguage(value) {
      const options = {
        id: this.currentProfileId,
        locale: value
      };
      this.lang = value;

      this.$root.$i18n.locale = value;
      this.$store.commit("SET_LANGUAGE", value);
      await this.$store.dispatch("SAVE_MAIN_USER_CONFIG");
      this.$store.commit("UPDATE_PROFILES_TREE", options);
    },
    async logout() {
      await this.$store.dispatch("SAVE_MAIN_USER_CONFIG");
      this.$store.commit("CLEAR_USER_DATA");
      this.$router.push({ path: "/login" });
    }
  },
  mounted() {
    this.themeSwitcher = this.theme === "dark-theme" ? true : false;
    this.langSwitcher = this.lang === "en" ? true : false;
  }
};
</script>

<style lang="scss">
.account-menu-popover {
  top: 50px !important;

  &.el-popper[x-placement^="bottom"] {
    margin-top: 0px;
  }

  padding: 0 !important;

  .popper__arrow {
    display: none !important;
  }
}

.account-menu {
  &__button {
    display: flex;
    align-items: center;
    padding-left: 10px;
    padding-right: 10px;
    height: 42px;
    cursor: pointer;

    &:hover {
      background-color: rgba(255, 255, 255, 0.05);
    }

    &-ava {
      width: 28px;
      height: 28px;
      position: relative;
      border-radius: 50%;
      overflow: hidden;

      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        height: 120%;
        width: auto;
      }
    }

    & > i {
      color: var(--text_primary) !important;
      font-size: 14px;
      margin-left: 5px;
    }
  }
  &__no-avatar {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-image: url("../../../assets/images/icons/avatar_white.svg");
    background-size: 75%;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    border-radius: 50%;
  }
  &__info {
    height: 65px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid;
    padding: 20px;
    border-color: var(--dividers_low_contrast) !important;
  }
  &__avatar {
    min-height: 64px;
    min-width: 64px;
    max-height: 64px;
    max-width: 64px;
    box-sizing: border-box;
    position: relative;
    border: 1px solid;
    overflow: hidden;
    border-radius: 50%;
    border-color: var(--dividers_low_contrast) !important;

    img {
      position: absolute;
      width: auto;
      height: 120%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .account-menu__no-avatar {
      background-image: url("../../../assets/images/icons/avatar.svg");
    }
  }
  &__user-info {
    margin-left: 14px;
  }
  &__list {
    padding: 10px 0;
  }
  &__item {
    overflow: hidden;
    position: relative;
    &-wrap {
      cursor: pointer;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 5px 20px;
      height: calc(100% - 10px);
      width: calc(100% - 40px);
      &:hover {
        background-color: rgba(var(--accent_primary), 0.15);
      }
    }
    &.devided {
      padding-top: 20px;
      &:before {
        position: absolute;
        top: 10px;
        left: 0;
        content: "";
        display: block;
        width: 100%;
        height: 1px;
        border-bottom: 1px solid;
        border-color: var(--dividers_low_contrast) !important;
      }
    }
    div.r-switch {
      opacity: 1 !important;
      .el-switch__core {
        cursor: pointer !important;
      }
    }
  }
  &__logout-icon {
    width: 16px;
    height: 16px;
    margin-right: 12px;
  }
}
</style>

<i18n>
{
  "ru": {
    "account:title" : "Аккаунт",
    "account:about" : "О системе",

    "account:theme" : "Темное оформление",
    
    "account:lang" : "English language",
    "account:settings-reset" : "Сброс настроек профиля",

    "account:exit" : "Выход"
  },
  "en": {
    "account:title" : "Account",
    "account:about" : "About",

    "account:theme" : "Dark theme",
    "account:lang" : "English language",
    "account:settings-reset" : "Reset profile config",

    "account:exit" : "Exit"
  }
}
</i18n>
